module.exports = __webpack_public_path__ + "static/img/icon-email.96ec70c2.png";